import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import React, {useState} from 'react'
import InfoBox from './InfoBox';
import { translate } from '../Services/translation'

export default function DimensionSearch({filters, tireUrl, onMoveOn, infoPopupImage, infoPopupContent}) {
    const [WidthInMm, setWidth] = useState("205")
    const [Height, setHeight] = useState("55")
    const [Diameter, setDiamater] = useState("16")
    const [TireType, setTireType] = useState("Sommardäck")

    const sizeFilters = {
        WidthInMm,
        Height,
        Diameter
    }

    const handleUpdateValue = (id, value) => {
        switch(id) {
            case "WidthInMm":
                setWidth(value)
                break
            case "Height":
                setHeight(value)
                break
            case "Diameter":
                setDiamater(value)
                break
        }
    }

    const getMoveOnLink = () => {
        const diameterQuery = `Diameter=${Diameter}`
        const heightQuery = `Height=${Height}`
        const widthinmmQuery = `WidthInMm=${WidthInMm}`
        const tireTypeQuery = `TireType=${TireType}`

        return `${tireUrl}?${diameterQuery}&${heightQuery}&${widthinmmQuery}&${tireTypeQuery}`
    }

    return (
        <div className="vehicle-finder__dimension-search" style={{color: "white"}}>
            <h3>{translate('ecom.startpage.findtires')}</h3>

            <div>
                <div style={{display: "flex", justifyContent: "right"}}>
                <InfoBox darkMode={true} right={true}>
                    <img alt="Dack-forklaring.png" src={infoPopupImage} />
                    <div dangerouslySetInnerHTML={{__html: infoPopupContent}}></div>
                </InfoBox>
                </div>
                <div className="vehicle-finder__dimension-search__size-filter-container">
                    {[filters?.WidthInMm, filters?.Height, filters?.Diameter].map(filter => 
                        (
                            <div key={filter?.id}>
                                <b>{filter?.label}</b>
                                <Select
                                    inputProps={{MenuProps: {disableScrollLock: true}}}
                                    value={sizeFilters[filter.id]}
                                    onChange={(e) => handleUpdateValue(filter.id, e.target.value)}
                                    displayEmpty
                                    fullWidth
                                >
                                    {filter?.options?.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                        )
                    )}
                </div>
            </div>

            <div className="vehicle-finder__dimension-search__type-filter-container">
                <b>{translate('ecom.startpage.tiretype')}</b>
                <Select
                    inputProps={{MenuProps: {disableScrollLock: true}}}
                    value={TireType}
                    onChange={(e) => setTireType(e.target.value)}
                    displayEmpty
                    fullWidth
                >
                    {filters?.TireType?.options?.filter(option => option.id.length > 0).map(option => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </div>
            <div style={{textAlign: "center"}} >
                <a className="vehicle-finder__dimension-search__continue-button" href={getMoveOnLink()}>
                    {translate('ecom.startpage.moveon')}
                </a>
            </div>
        </div>
    )
}